import img1 from "../assests/marie1.JPEG";
import img2 from "../assests/marie2.JPEG";
import img3 from "../assests/marie3.JPEG";
import img4 from "../assests/marie4.JPEG";
import img5 from "../assests/shayna1.JPEG";
import img6 from "../assests/shayna2.JPEG";
import img7 from "../assests/liz3.JPEG";
import img8 from "../assests/liz1.JPEG";
import img9 from "../assests/liz4.JPEG";
import img10 from "../assests/liz2.JPEG";

import pic from "../assests/u98G.png";

export const img = [
  {
    id: 1,
    url: img1,
    text: `Marie at Umbrella Alley`,
  },
  {
    id: 7,
    url: img7,
    text: `Liz in Hayes Valley`,
  },
  {
    id: 2,
    url: img2,
    text: `Marie at a cable car`,
  },
  {
    id: 3,
    url: img3,
    text: `Marie at Ghirardelli Square`,
  },
  {
    id: 4,
    url: img4,
    text: `Marie inside a cable car`,
  },
  {
    id: 5,
    url: img5,
    text: `Shayla at the Ferry Building`,
  },
  {
    id: 6,
    url: img6,
    text: `Shayla at Pier 27`,
  },
  {
    id: 8,
    url: img8,
    text: `Liz at an ice cream store`,
  },
  {
    id: 9,
    url: img9,
    text: `Liz in Hayes Valley`,
  },
  {
    id: 10,
    url: img10,
    text: `Liz on a scooter`,
  },
];

export const reviewsData = [
  {
    id: 1,
    img: pic,
    title: "Lorem ipsum",
    description: "“Lorem ipsum dolor sit amet consectetur. Vitae eros!”",
  },
  {
    id: 2,
    img: pic,
    title: "Lorem ipsum",
    description: "“Lorem ipsum dolor sit amet consectetur. Vitae eros!”",
  },
  {
    id: 3,
    img: pic,
    title: "Lorem ipsum",
    description: "“Lorem ipsum dolor sit amet consectetur. Vitae eros!”",
  },
];
